// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;

function MM_cmp_export_state_to_url(props) {
  var onClose = props.onClose;
  var match = React.useState(function () {
        
      });
  var setCopiedToClipboard = match[1];
  var $$location = window.location;
  var origin = $$location.origin;
  var pathname = $$location.pathname.replace(/\/v\d+\//g, "/latest/");
  var url = origin + pathname + "?editorState=" + props.editorStateBase64;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(Button, {
                                onClick: (function (param) {
                                    Expln_utils_promise.promiseMap(MM_react_common.copyToClipboard(url), (function (param) {
                                            Curry._1(setCopiedToClipboard, (function (timerId) {
                                                    if (timerId !== undefined) {
                                                      Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                                    }
                                                    return Caml_option.some(Common.$$setTimeout((function (param) {
                                                                      Curry._1(setCopiedToClipboard, (function (param) {
                                                                              
                                                                            }));
                                                                    }), 1000));
                                                  }));
                                          }));
                                  }),
                                variant: "contained",
                                style: {
                                  width: "90px"
                                },
                                children: Caml_option.some(Belt_Option.isSome(match[0]) ? "Copied" : "Copy")
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onClose, undefined);
                                  }),
                                children: "Close"
                              })), React.createElement("pre", {
                            style: {
                              overflow: "auto"
                            }
                          }, url)))
            });
}

var make = MM_cmp_export_state_to_url;

exports.make = make;
/* react Not a pure module */
